import { useEffect, useState } from "react";
import {
  CompanyManageSetCompanyStoreStock,
  ProductFilterProducts,
  CompanyManageGetCompanyStoreStock,
  CompanyManageMyStore,
  CompanyManageGetProductCompany,
  CompanyManageGetAutoStock,
  ProductFilterBerand,
} from "../../Api/Services";
import { toast } from "react-toastify";
import imgPlus from "../../assets/Icon/execution.png";
import { confirmAlert } from "react-confirm-alert";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompanyStoreStock() {
  const [isLoading, setLoading] = useState(true);
  const [CompanyStore, setCompanyStore] = useState([]);
  const [Product, setProduct] = useState([]);
  const [Data, setData] = useState([]);
  const [ProductCompany, setProductCompany] = useState([]);
  const [Errors, setErrors] = useState([]);
  const [AllStock, setAllStock] = useState([]);
  const [CompanyStoreId, setCompanyStoreId] = useState();
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [SearchName, setSearchName] = useState("");

  const start = async () => {
    setData([]);
    setProduct([]);
    setCompanyStore([]);
    setCompanyStoreId();
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        setCompanyStore(CompanyManageMyStoreData.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);

          const ProductFilterProductsData = await ProductFilterProducts({});
          if (
            ProductFilterProductsData.status &&
            ProductFilterProductsData.status === 200
          ) {
            setProduct(ProductFilterProductsData.data.data.data);
            let data = [];
            ProductFilterProductsData.data.data.data.forEach((element) => {
              let model = {
                ProductId: element.id,
                Stock: 0,
              };
              data.push(model);
            });
            setData(data);

            if (
              CompanyManageMyStoreData?.data.data.length > 0 &&
              data?.length > 0
            ) {
              let id = CompanyManageMyStoreData.data.data[0].companyStoreId;
              let idCompany =
                CompanyManageMyStoreData.data.data[0].companyStoreCompanyId;
              setCompanyStoreId(id);

              const CompanyManageGetCompanyStoreStockData =
                await CompanyManageGetCompanyStoreStock(id);
              if (
                CompanyManageGetCompanyStoreStockData.status &&
                CompanyManageGetCompanyStoreStockData.status === 200
              ) {
                let data1 = [...data];
                data1.forEach((element) => {
                  element.Stock = 0;
                });
                setAllStock(CompanyManageGetCompanyStoreStockData.data.data);
                CompanyManageGetCompanyStoreStockData.data.data.forEach(
                  (element) => {
                    data1.find((e) => e.ProductId == element.productId).Stock =
                      element.stock;
                  },
                );
                setData(data1);
                const CompanyManageGetProductCompanyData =
                  await CompanyManageGetProductCompany(idCompany);
                if (
                  CompanyManageGetProductCompanyData.status &&
                  CompanyManageGetProductCompanyData.status === 200
                ) {
                  setProductCompany(
                    CompanyManageGetProductCompanyData.data.data,
                  );
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const Add = async () => {
    setLoading(true);
    try {
      let model = {
        CompanyStoreId: CompanyStoreId,
        Product: Data,
      };
      const CompanyManageSetCompanyStoreStockData =
        await CompanyManageSetCompanyStoreStock(model);
      if (
        CompanyManageSetCompanyStoreStockData.status &&
        CompanyManageSetCompanyStoreStockData.status === 200
      ) {
        toast.success("ثبت اطلاعات  با موفقیت انجام شد");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const setStore = async (id, idCompany) => {
    setCompanyStoreId(id);
    setLoading(true);
    try {
      const CompanyManageGetCompanyStoreStockData =
        await CompanyManageGetCompanyStoreStock(id);
      if (
        CompanyManageGetCompanyStoreStockData.status &&
        CompanyManageGetCompanyStoreStockData.status === 200
      ) {
        let data = [...Data];
        data.forEach((element) => {
          element.Stock = 0;
        });
        setAllStock(CompanyManageGetCompanyStoreStockData.data.data);
        CompanyManageGetCompanyStoreStockData.data.data.forEach((element) => {
          data.find((e) => e.ProductId == element.productId).Stock =
            element.stock;
        });
        setData(data);
        const CompanyManageGetProductCompanyData =
          await CompanyManageGetProductCompany(idCompany);
        if (
          CompanyManageGetProductCompanyData.status &&
          CompanyManageGetProductCompanyData.status === 200
        ) {
          setProductCompany(CompanyManageGetProductCompanyData.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSearch = (id, e) => {
    const newForm = [...Data];
    newForm.find((e) => e.ProductId == id).Stock = e.target.value;
    setData(newForm);
  };

  const confirmAuto = (e) => {
    confirmAlert({
      title: "بروزرسانی اتوماتیک موجودی",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => AutoItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const AutoItem = async (e) => {
    try {
      setLoading(true);
      const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(e);
      if (
        CompanyManageGetAutoStockData.status &&
        CompanyManageGetAutoStockData.status === 200
      ) {
        setErrors(CompanyManageGetAutoStockData.data.data);
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
          p.productBerandId,
          p.productTypeId,
          p.productSeriesId,
          p.symbol,
          p.productSeriesEndId,
          p.productRamId,
          p.productRomId,
          p.productNetworkId,
          p.productCountryId,
          p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-item-center flex-column">
            {Errors.map((item) => (
              <p>{item}</p>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {CompanyStore &&
                CompanyStore.map((item, key) => (
                  <div className="border border-3 border-black m-2 rounded">
                    {item.companyStoreCompanyWarehouseType && (
                      <button
                        className={`m-2 border-0 rounded ${
                          item.companyStoreCompanyWarehouseType &&
                          " bg-warning pointer"
                        }`}
                        onClick={() => {
                          confirmAuto(item.companyStoreId);
                        }}
                      >
                        <img height={40} src={imgPlus} alt="" />
                      </button>
                    )}
                    <button
                      onClick={() => {
                        setStore(
                          item.companyStoreId,
                          item.companyStoreCompanyId,
                        );
                      }}
                      className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                        CompanyStoreId == item.companyStoreId
                          ? "bg-warning"
                          : ""
                      }`}
                    >
                      {item.companyStoreCompanyName +
                        " ( " +
                        item.companyStoreName +
                        " ) "}
                    </button>
                  </div>
                ))}
            </div>

            {CompanyStoreId && (
              <div className="w-100">
                <div className="d-flex justify-content-between align-items-center w-100 ">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                  <h5>
                    تعداد کل کالای انبار :
                    {AllStock.map((w) => w.stock).reduce(
                      (sum, value) => sum + value,
                      0,
                    )}
                  </h5>
                </div>
                <div className="d-flex">
                  <InputCus
                    className="m-2"
                    type="text"
                    name="name"
                    id="name"
                    text="نام"
                    value={SearchName}
                    onChange={(e) => {
                      setSearchName(e.target.value);
                    }}
                  />
                </div>
                {brands.map(
                  (b, key) =>
                    Product.filter((e) => e.productBerandId == b.id).length >
                      0 && (
                      <>
                        <div
                          key={b}
                          className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                          onClick={() => handleClick(b.id)}
                        >
                          <h5>
                            {b.name}
                            {" - "}
                            {AllStock.filter(
                              (q) => q.productProductBerandId === b.id,
                            )
                              .map((w) => w.stock)
                              .reduce((sum, value) => sum + value, 0)}
                          </h5>
                        </div>
                        {activeItem === b.id && (
                          <div className="d-flex justify-content-center align-items-center w-100 tableC">
                            <table
                              className="table tableMore"
                              style={{ lineHeight: "normal" }}
                            >
                              <thead className="sticky-header">
                                <tr className="trTable">
                                  <th>نام کالای</th>
                                  <th>رنگ</th>
                                  <th>کد کالا در شرکت</th>
                                  <th>موجودی</th>
                                </tr>
                              </thead>

                              {Product &&
                                groupProducts(Product).map((group, gIndex) => (
                                  <tbody key={gIndex}>
                                    {group
                                      .filter((e) => e.productBerandId == b.id)
                                      .filter((itemPro) => {
                                        const productFilter =
                                          SearchName?.toUpperCase?.() || "";
                                        const Pro =
                                          (
                                            (itemPro.productTypeName != " " &&
                                              itemPro.productTypeName + " ") +
                                            (itemPro.productSeriesName != " " &&
                                              itemPro.productSeriesName) +
                                            itemPro.symbol +
                                            (itemPro.productSeriesEndName != " "
                                              ? itemPro.productSeriesEndName +
                                                " "
                                              : " ") +
                                            (itemPro.productRamName != " " &&
                                              itemPro.productRamName + "/") +
                                            (itemPro.productRomName != " " &&
                                              itemPro.productRomName + " ") +
                                            (itemPro.productNetworkName !=
                                              " " &&
                                              itemPro.productNetworkName +
                                                " ") +
                                            (itemPro.productCountryName !=
                                              " " &&
                                              itemPro.productCountryName +
                                                " ") +
                                            (itemPro.isInsurance && "بیمه")
                                          )?.toUpperCase?.() || "";
                                        return Pro.includes(productFilter);
                                      })
                                      .map((itemPro, iIndex) => {
                                        return (
                                          <tr key={itemPro.id}>
                                            {iIndex === 0 && (
                                              <>
                                                <td rowSpan={group.length}>
                                                  {itemPro.productTypeName !=
                                                    " " &&
                                                    itemPro.productTypeName +
                                                      " "}
                                                  {itemPro.productSeriesName !=
                                                    " " &&
                                                    itemPro.productSeriesName}
                                                  {itemPro.symbol}
                                                  {itemPro.productSeriesEndName !=
                                                  " "
                                                    ? itemPro.productSeriesEndName +
                                                      " "
                                                    : " "}
                                                  {itemPro.productRamName !=
                                                    " " &&
                                                    itemPro.productRamName +
                                                      "/"}
                                                  {itemPro.productRomName !=
                                                    " " &&
                                                    itemPro.productRomName +
                                                      " "}
                                                  {itemPro.productNetworkName !=
                                                    " " &&
                                                    itemPro.productNetworkName +
                                                      " "}
                                                  {itemPro.productCountryName !=
                                                    " " &&
                                                    itemPro.productCountryName +
                                                      " "}
                                                  {itemPro.isInsurance &&
                                                    "بیمه"}
                                                </td>
                                              </>
                                            )}
                                            <td>
                                              {" "}
                                              {itemPro.productColorName}{" "}
                                            </td>
                                            <td>
                                              {
                                                ProductCompany.find(
                                                  (e) =>
                                                    e.productId == itemPro.id,
                                                )?.code
                                              }
                                            </td>
                                            <td>
                                              <input
                                                disabled={
                                                  ProductCompany.find(
                                                    (e) =>
                                                      e.productId == itemPro.id,
                                                  ) == null
                                                }
                                                onChange={(e) => {
                                                  handleChangeSearch(
                                                    itemPro.id,
                                                    e,
                                                  );
                                                }}
                                                value={
                                                  Data.find(
                                                    (e) =>
                                                      e.ProductId == itemPro.id,
                                                  ).Stock
                                                }
                                              />
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                ))}
                            </table>
                          </div>
                        )}
                      </>
                    ),
                )}
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyStoreStock;
